<script>
    export default {
        props: {
            data: Object,
            updateData: Function,
        },
        async mounted() {
            if (this.data.asset_type_id == null) {
                this.updateData(
                    this.$store.getters.ASSET_TYPE_IMAGES,
                    'asset_type_id',
                    false,
                    true
                );
            }
        },
        computed: {
            assetType() {return this.$store.getters.ASSET_TYPES},
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Name:</label>
        <input 
            type="text"
            class="right_input mt_5 mb_10"
            :value="data['name']"
            @change="updateData($event, 'name')"
        >

        <label>Asset Type:</label>
        <select
            class="right_input mt_5 mb_10"
            :value="data['asset_type_id']"
            @change="updateData($event, 'asset_type_id')"
        >
            <option
                v-for="(assetTypeValue, assetTypeIndex) in assetType" :key="assetTypeIndex"
                :value="assetTypeValue['id']"
            >{{ assetTypeValue['name'] }}</option>
        </select>

        <label>
            <input 
                type="checkbox"
                :checked="data['is_hq']"
                @change="updateData($event, 'is_hq', true)"
            >
            High Quality
        </label>
    </div>
</template>